import { React, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import ExpiredMemberView from '../../Model/Individual/MemberModel/ExpiredMemberView.js';

import FetchModule from '../../Model/Share/Network/FetchModule.js';

function ExpiredMemberInfoPage() {
  const history = useHistory();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const ViewRef = useRef();

  useEffect(() => {
    ViewRef.current.setData(data);
  }, [data])

  useEffect(() => {
    setIsLoading(true);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('member/expired/', 'POST');

        if (responseData.status === 200) {
          let newData = responseData.data.slice();

          setData(newData);
          setIsLoading(false);
        }
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }, [history])

  return (
    <TopLevelWrapper>
      <ExpiredMemberView ref={ViewRef} data={data} isLoading={isLoading}/>
    </TopLevelWrapper>
  )
}

export default ExpiredMemberInfoPage;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;